/**
 * Open File Action
 * Opens a file in the file viewer pane
 */

import { Datum } from "../datastructure";
import { ActionDefinition, ActionContext, getFilePayload } from "./types";
import openFileService from "@/components/FpAppV4/services/openFile";

/**
 * Opens a file in the viewer
 */
export async function openFile(
  datum: Datum,
  context: ActionContext
): Promise<void> {
  const payload = getFilePayload(datum);
  if (!payload) {
    console.error("openFile: Cannot open non-file datum");
    return;
  }

  openFileService({
    fileId: payload.fileId,
    fileName: payload.fileName,
    fileType: payload.fileType,
  });
}

/**
 * Action definition for context menu
 */
export const openFileAction: ActionDefinition = {
  config: {
    action: "open-file",
    label: "Open File",
  },
  isApplicable: (datum) => datum.type === "file",
  execute: openFile,
};
